import React from 'react';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { useUpdateUserTelegramMutation } from 'app/store';
import { useDialog } from 'components/layouts/page-with-dialog/dialog-context';
import useProfile from 'hooks/use-update-profile-query';
import { immediateToast } from 'utils/toast';
import { handleServerErrors } from 'utils/utils';

const DisableTelegramBotForm: React.FC = () => {
    const { profile, update } = useProfile();
    const { closeDialog } = useDialog();
    const [updateTelegram, { isLoading }] = useUpdateUserTelegramMutation();

    const handleDisable = () => {
        if (!profile) return;

        updateTelegram({ telegram: '' })
            .unwrap()
            .then(() => {
                update({
                    ...profile,
                    telegram_id: '',
                });

                immediateToast('success', {
                    message: 'ربات تلگرام غیرفعال شد',
                    timeout: 2000,
                });
                closeDialog('disable-telegram-bot');
            })
            .catch((error) => {
                handleServerErrors(error);
            });
    };

    return (
        <>
            <Typography
                sx={{
                    color: 'text.secondary',
                    fontSize: 13,
                    lineHeight: 2,
                    textAlign: 'center',
                    px: 0.5,
                }}
            >
                با غیرفعالسازی ربات، شناسه تلگرام ثبت‌شده برای حساب شما حذف
                می‌شود. آیا از غیرفعالسازی ربات اطمینان دارید؟
            </Typography>

            <LoadingButton
                fullWidth
                onClick={handleDisable}
                loading={isLoading}
                color="error"
                variant="contained"
                sx={{
                    mt: 2.5,
                    minHeight: 40,
                    color: '#fff !important',
                    '&.Mui-disabled': {
                        color: 'rgba(255,255,255,.65) !important',
                    },
                }}
            >
                تایید و غیرفعالسازی ربات
            </LoadingButton>
        </>
    );
};

export default DisableTelegramBotForm;
